import { BaseSpline2d } from "./BaseSpline2d.mjs";
import { LineSegment2d } from "./LineSegment2d.mjs";
class Polyline2d extends BaseSpline2d {
  constructor(points, k = 1.2, p = 20) {
    super(points, k, p);
    this.segments = this.getSegmentsFromPoints(points, p);
  }
  segments;
  getSegmentsFromPoints(points, p = 50) {
    const segments = [];
    for (let i = 0; i < points.length - 1; i++) {
      segments.push(new LineSegment2d(points[i], points[i + 1], p));
    }
    return segments;
  }
  static FromPoints(points) {
    return new Polyline2d(points);
  }
}
export {
  Polyline2d
};
//# sourceMappingURL=Polyline2d.mjs.map
